/// <amd-module name="SuiteCommerce.Blog.BlogHome.View"/>
var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b;
          }) ||
        function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };
    return function (d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype =
        b === null
          ? Object.create(b)
          : ((__.prototype = b.prototype), new __());
    };
  })();
define("SuiteCommerce.Blog.BlogHome.View", [
  "require",
  "exports",
  "Backbone",
  "SuiteCommerce.Blog.BlogHome.Model",
  "sc_blog_home_default_layout.tpl",
  "SuiteCommerce.Blog.BlogHome.Configuration",
  "SuiteCommerce.Blog.Common",
  "SuiteCommerce.Blog.PostList.View",
  "SuiteCommerce.Blog.PostList.Model",
  "SuiteCommerce.Blog.PostCard.View",
  "SuiteCommerce.Blog.Post.Collection",
  "SuiteCommerce.Blog.Common.Searcher.Helper",
  "SuiteCommerce.Blog.PostSearch.View",
  "SuiteCommerce.Blog.TaxonomyNavigation.View",
  "SuiteCommerce.Blog.TaxonomyNavigation.Model",
  "SuiteCommerce.Blog.Common.ParameterProcessor",
  "SuiteCommerce.Blog.Pagination.View",
  "SuiteCommerce.Blog.Pagination.Model",
  "SuiteCommerce.Blog.DataProvider.Category.Model",
  "SuiteCommerce.Blog.DataProvider",
  "SuiteCommerce.Blog.PostSearch.Model",
  "SuiteCommerce.Blog.Pagination.Configuration",
  "SuiteCommerce.Blog.PostSearch.Configuration",
  "SuiteCommerce.Blog.EmptyState.View",
  "SuiteCommerce.Blog.EmptyState.Model",
  "SuiteCommerce.Blog.SuggestionsList.View",
  "SuiteCommerce.Blog.SuggestionsList.Model",
  "SuiteCommerce.Blog.Instrumentation",
  "SuiteCommerce.Blog.LatestPosts.View",
  "SuiteCommerce.Blog.LatestPosts.Model",
  "SuiteCommerce.Blog.LatestPosts.Slide.Collection",
  "SuiteCommerce.Blog.ExtCarousel.Model",
], function (
  require,
  exports,
  Backbone_1,
  BlogHome_Model_1,
  blogHomeTemplate,
  BlogHome_Configuration_1,
  Common_1,
  PostList_View_1,
  PostList_Model_1,
  PostCard_View_1,
  Post_Collection_1,
  BlogPostSearcher_Helper_1,
  PostSearch_View_1,
  TaxonomyNavigation_View_1,
  TaxonomyNavigation_Model_1,
  ParameterProcessor_1,
  Pagination_View_1,
  Pagination_Model_1,
  DataProvider_Category_Model_1,
  DataProvider_1,
  PostSearch_Model_1,
  Pagination_Configuration_1,
  PostSearch_Configuration_1,
  EmptyState_View_1,
  EmptyState_Model_1,
  SuggestionsList_View_1,
  SuggestionsList_Model_1,
  Instrumentation_1,
  LatestPosts_View_1,
  LatestPosts_Model_1,
  LatestPosts_Slide_Collection_1,
  ExtCarousel_Model_1
) {
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.BlogHomeView = void 0;
  var BlogHomeView = /** @class */ (function (_super) {
    __extends(BlogHomeView, _super);
    function BlogHomeView(options) {
      var _this = _super.call(this, options) || this;
      _this.template = blogHomeTemplate;
      _this.title =
        BlogHome_Configuration_1.BlogHomeConfiguration.blogHomeTitle;
      _this.showEmptyState = false;
      _this.defaultPageNumber = 1;
      _this.navigationData =
        ParameterProcessor_1.ParameterProcessor.getProcessedNavigationData(
          Backbone_1.history.getFragment()
        );
      _this.activeFilter = _this.getActiveFilter();
      _this.updateTitle();
      _this.updateBreadcrumbs();
      _this.model = new BlogHome_Model_1.BlogHomeModel();
      _this.setupDataProviderListener();
      _this.setupLatestPostsView();
      _this.setupFeaturedPostListView();
      _this.setupFeaturedPostInCategoryView();
      _this.setupPostListViews();
      _this.setupPostListPagination();
      _this.setupPostSearchView();
      _this.setupTaxonomyNavigationView();
      return _this;
    }
    BlogHomeView.prototype.setupDataProviderListener = function () {
      var _this = this;
      DataProvider_1.DataProvider.entitiesModel.on("sync", function () {
        _this.activeFilter = _this.getActiveFilter();
        _this.updateTitle();
        _this.updateBreadcrumbs();
        _this.render();
      });
    };

    // Finis Custom Axim -fetching finis youtube videos
    BlogHomeView.prototype.beforeShowContent = function () {
      var self = this;
      var renderPromise = jQuery.Deferred();
      const ytPromise = fetch(
        `https://${window.location.hostname}/app/site/hosting/scriptlet.nl?script=2149&deploy=1&compid=1144330&ns-at=AAEJ7tMQkPt5yOPKnadmgHd-6q2j-f0Vn6HRCYiZ1mcx2iELWNs`
        
      )
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            this.youtubeVideos = JSON.parse(result.link);
          }
        })
        .catch((err) => {
          console.log(err, "fetching yt videos");
        });

      const instaPromise = fetch(
        `https://${window.location.hostname}/app/site/hosting/scriptlet.nl?script=2151&deploy=1&compid=1144330&ns-at=AAEJ7tMQ2pp5iJnInWTsy6FPz0Vcp4DXnnCvydW0992VBjUqfSY`
      )
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            this.instagramMedia = JSON.parse(result.media);
          }
        })
        .catch((err) => {
          console.log(err, "fetching insta media");
        });

      Promise.allSettled([ytPromise, instaPromise])
        .then(() => renderPromise.resolve())
        .catch(() => renderPromise.resolve());

      return renderPromise;
    };
    BlogHomeView.prototype.getActiveFilter = function (navigationData) {
      if (navigationData === void 0) {
        navigationData = this.navigationData;
      }
      var filter = { type: "" };
      if (navigationData && navigationData.mainTaxonomy) {
        var taxonomy = navigationData.mainTaxonomy;
        if (taxonomy.name === Common_1.AvailableTaxonomies.category) {
          filter.type = Common_1.AvailableTaxonomies.category;
          var category =
            DataProvider_1.DataProvider.categories.getCategoryByURLComponent(
              taxonomy.value
            ) ||
            DataProvider_1.DataProvider.categories.getCategoryById(
              taxonomy.value
            );
          if (taxonomy.value === Common_1.DefaultTaxonomies.all.urlComponent) {
            category = new DataProvider_Category_Model_1.CategoryModel({
              name: Common_1.DefaultTaxonomies.all.name,
            });
          }
          if (category) {
            filter.label = category.name;
            filter.value = taxonomy.value;
          }
        }
        if (taxonomy.name === Common_1.AvailableTaxonomies.term) {
          filter.type = Common_1.AvailableTaxonomies.term;
          var term =
            DataProvider_1.DataProvider.terms.getTermByURLComponent(
              taxonomy.value
            ) || DataProvider_1.DataProvider.terms.getTermById(taxonomy.value);
          var termName = term ? term.name : "";
          if (termName) {
            filter.label = termName;
            filter.value = taxonomy.value;
          }
        }
        if (taxonomy.name === Common_1.AvailableTaxonomies.tag) {
          filter.type = Common_1.AvailableTaxonomies.tag;
          filter.label =
            BlogHome_Configuration_1.BlogHomeConfiguration.titleForTagSearch;
          filter.value = "#" + taxonomy.value.toUpperCase();
        }
        if (taxonomy.name === Common_1.AvailableTaxonomies.author) {
          filter.type = Common_1.AvailableTaxonomies.author;
          var author =
            DataProvider_1.DataProvider.authors.getAuthorByURLComponent(
              taxonomy.value
            ) ||
            DataProvider_1.DataProvider.authors.getAuthorById(taxonomy.value);
          if (author) {
            filter.label =
              BlogHome_Configuration_1.BlogHomeConfiguration.titleForAuthorSearch;
            filter.value = author.name;
          }
        }
      } else if (navigationData && navigationData.searchPhrase) {
        filter.type = ParameterProcessor_1.SearchPhraseSettings.keywords;
        filter.label =
          PostSearch_Configuration_1.PostSearchConfiguration.searchResultsLabel;
        filter.value = navigationData.searchPhrase;
      }
      return filter.type ? filter : null;
    };
    BlogHomeView.prototype.updateTitle = function () {
      var filter = this.activeFilter;
      if (filter && filter.label) {
        var value =
          filter.type === ParameterProcessor_1.SearchPhraseSettings.keywords ||
          filter.type === Common_1.AvailableTaxonomies.category ||
          filter.type === Common_1.AvailableTaxonomies.term
            ? ""
            : filter.value;
        this.title += " | " + filter.label + " " + value;
        this.postListTitle = { label: filter.label, text: value };
      } else {
        this.postListTitle = {
          label:
            BlogHome_Configuration_1.BlogHomeConfiguration.moreArticlesLabel,
          text: "",
        };
      }
    };
    BlogHomeView.prototype.updateBreadcrumbs = function () {
      var navigationData =
        ParameterProcessor_1.ParameterProcessor.getProcessedNavigationData(
          Backbone_1.history.getFragment()
        );
      var pages = navigationData
        ? this.getBreadcrumbEntries(this.getActiveFilter(navigationData))
        : [
            {
              text: BlogHome_Configuration_1.BlogHomeConfiguration
                .blogHomeTitle,
              href: "" + Common_1.BLOG_URL_BASE,
            },
          ];
      this.getBreadcrumbPages = function () {
        return pages;
      };
    };
    BlogHomeView.prototype.getBreadcrumbEntries = function (activeFilter) {
      var filter = activeFilter || this.activeFilter;
      var entries = [
        {
          text: BlogHome_Configuration_1.BlogHomeConfiguration.blogHomeTitle,
          href: "" + Common_1.BLOG_URL_BASE,
        },
      ];
      if (filter && filter.label) {
        var value =
          filter.type === ParameterProcessor_1.SearchPhraseSettings.keywords ||
          filter.type === Common_1.AvailableTaxonomies.category ||
          filter.type === Common_1.AvailableTaxonomies.term
            ? ""
            : filter.value;
        entries.push({ text: filter.label + " " + value, href: "" });
      }
      return entries;
    };
    BlogHomeView.prototype.setupLatestPostsView = function () {
      if (
        this.isHomePage() &&
        BlogHome_Configuration_1.BlogHomeConfiguration.showLatestPostsSection
      ) {
        var interval =
          BlogHome_Configuration_1.BlogHomeConfiguration
            .latestPostsCarouselInterval;
        this.latestPostView = new LatestPosts_View_1.LatestPostsView({
          model: new LatestPosts_Model_1.LatestPostsModel({
            interval: interval,
            carouselTitle:
              BlogHome_Configuration_1.BlogHomeConfiguration.latestPostsLabel,
            slides:
              new LatestPosts_Slide_Collection_1.LatestPostsSlideCollection(),
            transition: ExtCarousel_Model_1.Transition.fade,
            autoPlay: !!interval,
          }),
        });
      }
    };
    BlogHomeView.prototype.setupFeaturedPostListView = function () {
      var _this = this;
      if (
        this.isHomePage() ||
        (this.navigationData.pageNumber > 1 &&
          BlogHome_Configuration_1.BlogHomeConfiguration
            .showFeaturedArticlesInPagination)
      ) {
        var featuredTerm = this.getFeaturedTerm();
        if (!featuredTerm) {
          this.updateFeaturedListAfterDataProviderSync();
        }
        var viewModel = new PostList_Model_1.PostListModel({
          posts: this.model.featuredPosts,
          showPostCardsPlaceholders: true,
          postCardLayout: PostCard_View_1.PostCardLayout.vertical,
          postCardPlaceholdersQuantity: 4,
          title: featuredTerm ? featuredTerm.name : "",
        });
        this.featuredPostListView = new PostList_View_1.PostListView({
          model: viewModel,
        });
        this.model.featuredPosts
          .fetch(
            BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody({
              settings: { pageNumber: this.defaultPageNumber, pageSize: 5 },
              taxonomies: [
                {
                  name: Common_1.AvailableTaxonomies.term,
                  value: Common_1.DefaultTaxonomies.featured.defaultAlias,
                },
              ],
            })
          )
          .done(function () {
            _this.featuredPostListView.model.posts =
              new Post_Collection_1.PostCollection(
                _this.model.featuredPosts.slice(0, 4)
              );
            _this.featuredPostListView.model.showPostCardsPlaceholders = false;
            _this.featuredPostListView.model.hideList =
              _this.featuredPostListView.model.posts.size() === 0;
          });
      }
    };
    BlogHomeView.prototype.getFeaturedTerm = function () {
      return DataProvider_1.DataProvider.entitiesModel.terms.getTermByDefaultAlias(
        Common_1.DefaultTaxonomies.featured.defaultAlias
      );
    };
    BlogHomeView.prototype.updateFeaturedListAfterDataProviderSync =
      function () {
        var _this = this;
        DataProvider_1.DataProvider.entitiesModel.on("sync", function () {
          var featuredTerm = _this.getFeaturedTerm();
          if (featuredTerm) {
            _this.featuredPostListView.model.title = featuredTerm.name;
          }
        });
      };
    BlogHomeView.prototype.setupFeaturedPostInCategoryView = function () {
      var _this = this;
      var activeFilter = this.activeFilter;
      if (
        activeFilter &&
        activeFilter.type === Common_1.AvailableTaxonomies.category
      ) {
        if (DataProvider_1.DataProvider.entitiesModel.isSync) {
          this.fetchFeaturedPostInActiveCategory();
        } else {
          DataProvider_1.DataProvider.entitiesModel.on(
            "change:isSync",
            function () {
              _this.fetchFeaturedPostInActiveCategory();
            }
          );
        }
      }
    };
    BlogHomeView.prototype.fetchFeaturedPostInActiveCategory = function () {
      var _this = this;
      var activeFilter = this.activeFilter;
      var featuredInCategoryTerm =
        DataProvider_1.DataProvider.terms.getTermByDefaultAlias(
          Common_1.DefaultTaxonomies.featuredInCategory.defaultAlias
        );
      if (
        featuredInCategoryTerm &&
        featuredInCategoryTerm.isUsed &&
        activeFilter.value !== Common_1.DefaultTaxonomies.all.urlComponent
      ) {
        var posts_1 = new Post_Collection_1.PostCollection();
        posts_1
          .fetch(
            BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody({
              settings: { pageNumber: this.defaultPageNumber, pageSize: 5 },
              taxonomies: [
                {
                  name: Common_1.AvailableTaxonomies.term,
                  value: featuredInCategoryTerm.urlComponent,
                },
                {
                  name: Common_1.AvailableTaxonomies.category,
                  value: activeFilter.value,
                },
              ],
            })
          )
          .done(function () {
            if (posts_1.size() > 0) {
              _this.featuredPostsInCategoryView =
                new PostList_View_1.PostListView({
                  model: new PostList_Model_1.PostListModel({
                    title: featuredInCategoryTerm.name,
                    posts: new Post_Collection_1.PostCollection(
                      posts_1.slice(0, 4)
                    ),
                    showPostCardsPlaceholders: false,
                    postCardLayout: PostCard_View_1.PostCardLayout.vertical,
                    postCardPlaceholdersQuantity: 4,
                  }),
                });
              _this.render();
            }
          });
      }
    };
    BlogHomeView.prototype.setupPostListViews = function () {
      var _this = this;
      this.setupHeaderBlockPostListView();
      this.setupContentPostListView();
      this.setupAllPostListView();
      var pageNumber =
        this.navigationData && this.navigationData.pageNumber
          ? this.navigationData.pageNumber
          : this.defaultPageNumber;
      var searcherRequestLog = Instrumentation_1.default.getLog(
        "BlogPostSearcherRequest"
      );
      searcherRequestLog.startTimer();
      this.model.posts
        .fetch(
          BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody({
            taxonomies:
              this.navigationData && this.navigationData.mainTaxonomy
                ? this.navigationData.taxonomies
                : [],
            settings: {
              pageNumber: pageNumber,
              pageSize:
                Pagination_Configuration_1.PaginationConfiguration
                  .articlesByPage,
            },
            searchPhrase:
              this.navigationData && this.navigationData.searchPhrase
                ? this.navigationData.searchPhrase
                : "",
          })
        )
        .done(function (response) {
          searcherRequestLog.endTimer();
          var activeFilter = _this.activeFilter;
          if (
            _this.model.posts.totalInServer > 0 ||
            (activeFilter &&
              activeFilter.type ===
                ParameterProcessor_1.SearchPhraseSettings.keywords)
          ) {
            _this.showEmptyState = false;
            _this.headerBlockPostListView.model.showPostCardsPlaceholders = false;
            _this.headerBlockPostListView.model.posts =
              _this.model.headerBlockPostList;
            _this.contentPostListView.model.showPostCardsPlaceholders = false;
            _this.contentPostListView.model.posts = _this.model.contentPostList;
            _this.allPostListView.model.showPostCardsPlaceholders = false;
            _this.allPostListView.model.posts = _this.model.posts;
            _this.setupPostListPagination();
            if (
              activeFilter &&
              activeFilter.type ===
                ParameterProcessor_1.SearchPhraseSettings.keywords &&
              _this.model.posts.totalInServer === 0
            ) {
              if (DataProvider_1.DataProvider.entitiesModel.isSync) {
                _this.setupSuggestionsListView(activeFilter.value);
              } else {
                DataProvider_1.DataProvider.entitiesModel.on(
                  "change:isSync",
                  function () {
                    _this.setupSuggestionsListView(activeFilter.value);
                  }
                );
              }
            }
            _this.render();
          } else {
            _this.showEmptyState = true;
            _this.setupEmptyStateView(response);
          }
          searcherRequestLog.setParameters({
            activity: "Blog Post Searcher Request",
            totalTime: searcherRequestLog.getElapsedTimeForTimer(),
            instanceCount: response.total,
            subType: activeFilter ? activeFilter.type : "",
          });
          searcherRequestLog.submit();
          if (!activeFilter) {
            _this.createQuantityOfArticlesLog(response.total);
          }
        });
    };
    BlogHomeView.prototype.createQuantityOfArticlesLog = function (
      quantityOfLogs
    ) {
      var quantityOfArticlesLog = Instrumentation_1.default.getLog(
        "quantityOfArticlesLog"
      );
      quantityOfArticlesLog.setParameters({
        activity: "Quantity of Articles",
        instanceCount: quantityOfLogs,
      });
      quantityOfArticlesLog.submit();
    };
    BlogHomeView.prototype.setupSuggestionsListView = function (term) {
      var pinnedTaxonomies = [];
      var searchTerm = DataProvider_1.DataProvider.terms.getTermByURLComponent(
        Common_1.DefaultTaxonomies.search.defaultAlias
      );
      if (searchTerm && searchTerm.isUsed) {
        pinnedTaxonomies.push({
          name: Common_1.AvailableTaxonomies.term,
          value: searchTerm.urlComponent,
        });
      }
      this.suggestionsListView = new SuggestionsList_View_1.SuggestionsListView(
        {
          model: new SuggestionsList_Model_1.SuggestionsListModel({
            title:
              PostSearch_Configuration_1.PostSearchConfiguration.noSearchResultsLabel.replace(
                "[[term]]",
                '<span class="term">' + term + "</span>"
              ),
            suggestionMessage:
              PostSearch_Configuration_1.PostSearchConfiguration
                .noResultsArticleSuggestionMessage,
            searchOptions: {
              settings: { pageSize: 5, pageNumber: 1 },
              taxonomies: pinnedTaxonomies,
            },
            quantityOfSuggestions: 2,
          }),
        }
      );
    };
    BlogHomeView.prototype.setupEmptyStateView = function (response) {
      this.showEmptyState = true;
      var model;
      if (response.error) {
        model = this.getEmptyStateModelForError(
          response.error,
          response.errorMessage
        );
      } else {
        model = new EmptyState_Model_1.EmptyStateModel({
          label: BlogHome_Configuration_1.BlogHomeConfiguration.emptyStateLabel,
          message:
            BlogHome_Configuration_1.BlogHomeConfiguration.emptyStateMessage,
          actionButtonLabel:
            BlogHome_Configuration_1.BlogHomeConfiguration
              .emptyStateButtonLabel,
          actionButtonUrl:
            BlogHome_Configuration_1.BlogHomeConfiguration.defaultSearchUrl,
        });
      }
      this.emptyStateView = new EmptyState_View_1.EmptyStateView({
        model: model,
      });
      this.render();
    };
    BlogHomeView.prototype.getEmptyStateModelForError = function (
      error,
      errorMessage
    ) {
      var label = "";
      if (
        error ===
        BlogPostSearcher_Helper_1.BlogPostSearcherError.taxonomyNotFound
      ) {
        label =
          PostSearch_Configuration_1.PostSearchConfiguration.noSearchResultsLabel.replace(
            "[[term]]",
            '<span class="term">' + errorMessage.join(",") + "</span>"
          );
      } else {
        label = BlogHome_Configuration_1.BlogHomeConfiguration.emptyStateLabel;
      }
      return new EmptyState_Model_1.EmptyStateModel({
        label: label,
        message:
          BlogHome_Configuration_1.BlogHomeConfiguration.emptyStateMessage,
        actionButtonLabel:
          BlogHome_Configuration_1.BlogHomeConfiguration.emptyStateButtonLabel,
        actionButtonUrl:
          BlogHome_Configuration_1.BlogHomeConfiguration.defaultSearchUrl,
      });
    };
    BlogHomeView.prototype.setupPostListPagination = function () {
      if (!this.postListPagination) {
        this.postListPagination = new Pagination_View_1.PaginationView({
          model: new Pagination_Model_1.PaginationModel({
            pageSize:
              Pagination_Configuration_1.PaginationConfiguration.articlesByPage,
            total: 0,
            currentPage: this.defaultPageNumber,
          }),
        });
      } else {
        this.postListPagination.model.total = this.model.posts.totalInServer;
        if (this.navigationData && this.navigationData.pageNumber) {
          this.postListPagination.model.currentPage =
            this.navigationData.pageNumber;
        }
        this.postListPagination.generateButtons();
      }
    };
    BlogHomeView.prototype.setupAllPostListView = function () {
      var viewModel = new PostList_Model_1.PostListModel({
        posts: this.model.headerBlockPostList,
        showPostCardsPlaceholders: true,
        postCardLayout: PostCard_View_1.PostCardLayout.horizontal,
        postCardPlaceholdersQuantity: 4,
        highlightInCards:
          this.navigationData && this.navigationData.searchPhrase
            ? this.navigationData.searchPhrase
            : "",
      });
      this.allPostListView = new PostList_View_1.PostListView({
        model: viewModel,
      });
    };
    BlogHomeView.prototype.setupHeaderBlockPostListView = function () {
      var viewModel = new PostList_Model_1.PostListModel({
        posts: this.model.headerBlockPostList,
        showPostCardsPlaceholders: true,
        postCardLayout: PostCard_View_1.PostCardLayout.horizontal,
        postCardPlaceholdersQuantity: 2,
        highlightInCards:
          this.navigationData && this.navigationData.searchPhrase
            ? this.navigationData.searchPhrase
            : "",
      });
      this.headerBlockPostListView = new PostList_View_1.PostListView({
        model: viewModel,
      });
    };
    BlogHomeView.prototype.setupContentPostListView = function () {
      var viewModel = new PostList_Model_1.PostListModel({
        posts: this.model.contentPostList,
        showPostCardsPlaceholders: true,
        postCardLayout: PostCard_View_1.PostCardLayout.horizontal,
        postCardPlaceholdersQuantity: 4,
        highlightInCards:
          this.navigationData && this.navigationData.searchPhrase
            ? this.navigationData.searchPhrase
            : "",
      });
      this.contentPostListView = new PostList_View_1.PostListView({
        model: viewModel,
      });
    };
    BlogHomeView.prototype.setupPostSearchView = function () {
      this.postSearchView = new PostSearch_View_1.PostSearchView({
        model: new PostSearch_Model_1.PostSearchModel({
          phrase:
            this.navigationData && this.navigationData.searchPhrase
              ? this.navigationData.searchPhrase
              : "",
        }),
      });
    };
    BlogHomeView.prototype.setupTaxonomyNavigationView = function () {
      this.taxonomyNavigationView =
        new TaxonomyNavigation_View_1.TaxonomyNavigationView({
          model: new TaxonomyNavigation_Model_1.TaxonomyNavigationModel(),
          navigationData: this.navigationData,
        });
    };
    Object.defineProperty(BlogHomeView.prototype, "childViews", {
      get: function () {
        var _this = this;
        return {
          "PostSearch.View": function () {
            return _this.postSearchView;
          },
          "TaxonomyNavigation.View": function () {
            return _this.taxonomyNavigationView;
          },
          "SuggestionsList.View": function () {
            return _this.suggestionsListView;
          },
          "LatestPosts.View": function () {
            return _this.latestPostView;
          },
          "FeaturedPostList.View": function () {
            return _this.featuredPostListView;
          },
          "FeaturedPostsInCategory.View": function () {
            return _this.featuredPostsInCategoryView;
          },
          "HeaderBlockPostList.View": function () {
            return _this.headerBlockPostListView;
          },
          "ContentPostList.View": function () {
            return _this.contentPostListView;
          },
          "AllPostList.View": function () {
            return _this.allPostListView;
          },
          "PostListPagination.View": function () {
            return _this.postListPagination;
          },
          "EmptyState.View": function () {
            return _this.emptyStateView;
          },
        };
      },
      enumerable: false,
      configurable: true,
    });
    BlogHomeView.prototype.getContext = function () {
      var filter = this.activeFilter;

      return {
        url: Common_1.BLOG_URL_BASE,
        header: BlogHome_Configuration_1.BlogHomeConfiguration.blogHomeTitle,
        postListTitle: this.postListTitle,
        postListSize: this.model.posts.size(),
        showEmptyState: this.showEmptyState,
        isHomePage: this.isHomePage(),
        ytVideos: this.youtubeVideos || [],
        instagramMedia: this.instagramMedia || [],
        mainYtVideo: this.youtubeVideos
          ? `https://www.youtube.com/embed/${this.youtubeVideos[0].videoId}`
          : undefined,
        isPostListFiltered: this.isPostListFiltered(),
        isPostListFilteredByAuthor: !!(
          filter &&
          filter.type &&
          filter.type === Common_1.AvailableTaxonomies.author
        ),
        isPostListFilteredByCategory: !!(
          filter &&
          filter.type &&
          filter.type === Common_1.AvailableTaxonomies.category
        ),
        isPostListFilteredByTag: !!(
          filter &&
          filter.type &&
          filter.type === Common_1.AvailableTaxonomies.tag
        ),
        isPostListFilteredByTerm: !!(
          filter &&
          filter.type &&
          filter.type === Common_1.AvailableTaxonomies.term
        ),
        isPostListFilteredByPhrase: !!(
          filter &&
          filter.type &&
          filter.type === ParameterProcessor_1.SearchPhraseSettings.keywords
        ),
        showRssFeedLink:
          BlogHome_Configuration_1.BlogHomeConfiguration.showRssFeedLink,
      };
    };
    BlogHomeView.prototype.isHomePage = function () {
      return (
        !this.isPostListFiltered() &&
        (!this.navigationData ||
          (this.navigationData &&
            this.navigationData.pageNumber &&
            this.navigationData.pageNumber === 1))
      );
    };
    BlogHomeView.prototype.isPostListFiltered = function () {
      return !!(
        this.navigationData &&
        (this.navigationData.taxonomies || this.navigationData.searchPhrase)
      );
    };
    return BlogHomeView;
  })(Backbone_1.View);
  exports.BlogHomeView = BlogHomeView;
});
